import { useEffect } from "react";
import { StabilizedBridgeQuote } from "../quote";
import { observer } from "mobx-react";
import { useOneToolStore } from "../quote/hooks/useOneToolStore";
import { useParams } from 'react-router';

export const EditStabilizedBridge = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { stabilizedBridgeQuoteStore } = oneToolStore;
  const { loanId } = useParams<{ loanId: string }>();

  useEffect(() => {
    stabilizedBridgeQuoteStore.loadQuoteToEdit(loanId);
  }, [stabilizedBridgeQuoteStore, loanId]);

  return (<StabilizedBridgeQuote />);
});